import React, { useEffect, useState } from 'react'
import "./CSS/Header.css"
import tringle from "../Assets/Triangle-Exclamation-Point.jpg"
import alert from "../Assets/2014825.png"
import { connect, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import LeftPart from './LeftPart'



const Header3 = (props) => {
  const domain_current = useSelector((state) => state.project_reducer.current_domain)
  const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];


  const [username_, Setusername_] = useState("")

  const history = useHistory()


  useEffect(() => {
    Setusername_(props.username)
  }, [])

  const [currentHour, SetcurrentHour] = useState(null)
  const [currentMinute, SetcurrentMinute] = useState(null)
  const [currentDay, SetcurrentDay] = useState(null)
  const [currentDay2, SetcurrentDay2] = useState(null)
  const [currentyear, Setcurrentyear] = useState(null)
  const [currentmonth, Setcurrentmonth] = useState(null)


  setInterval(() => {
    let now = new Date();
    SetcurrentHour(now.getHours())
    SetcurrentMinute(now.getMinutes())
    SetcurrentDay(now.getDay())
    Setcurrentmonth(now.getMonth())
    Setcurrentyear(now.getFullYear())
    SetcurrentDay2(daysOfWeek[now.getDay()])

  }, 1000)

  const hamburger_click = e => {
    document.querySelector(".hamburger").classList.toggle("hamburger_active")
    document.querySelector(".left_menu").classList.toggle("left_menu_active")
  }


  return (
    <>
      <div className="left_menu">
        <LeftPart/>
      </div>
      <header>
        <nav>
          <div onClick={hamburger_click} className="hamburger">
            <span></span><span></span><span></span>
          </div>
          <div className="nav-left-part">
            <img src="https://havadurumu15gunluk.xyz/img_t/1/3-h.gif" alt="" />
            <div>10 .c</div>

          </div>
          <div className="middlepart-nav">
            <div className='nav-time-part'>{currentHour}:{currentMinute < 10 ? `0${currentMinute}` : currentMinute}</div>
            <div>
              <div style={{ marginLeft: "5%" }} className="date-part-nav">
                {currentDay < 10 ? `0${currentDay}` : currentDay}/{currentmonth + 1 < 10 ? `0${currentmonth + 1}` : currentmonth + 1}/{currentyear}
              </div>
              <div className="day-part-nav">
                {currentDay2}
              </div>
            </div>
          </div>
          <div className="right-part-nav">
            <div><img className='trinagle-alert' src={tringle} /></div>
            <div><img className='red_alarm' src={alert} alt="" /></div>
            <div className='user_profile_part'>
              <i onClick={() => {
                history.push("/profile")
              }} className="fa-solid fa-user fa-sm"></i>
              <p>{username_}</p>
            </div>
          </div>
        </nav>
        
      </header>
    </>
  )
}

const MapStateToProps = (state) => {
  return {
    username: state.auth_reducer.username,
    uid: state.auth_reducer.user_id
  }
}

export default connect(MapStateToProps)(Header3)